export type EmailForm = {
    email :string;
    subject :string;
    // message :string;
    attachment :string;
    tipo :string;
  };


export type ReportProgForm = {
                emailTo?      :string;
 };


export type ReportProg = {
  nomeditta?: string;
  coddipagente?: string;
  codprog?: string;
  desprog?: string;
  codnodo?: string;
  desnodo?: string;
  ore?: number;
  oreprep?: number;
  oreprev?: number;
  orerest?: number;
  orediff?: number;
};

export type ReportProgApiResponse = {
  results: Array<ReportProg>;
  count: number;
};

export function mapJsonToReportProgApiResponse(jsonData: any): ReportProgApiResponse {
  const mappedData: ReportProgApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
      nomeditta: item.NOMEDITTA,
      coddipagente: item.CODDIPAGENTE,
      codprog: item.CODPROG,
      desprog: item.DESPROG,
      codnodo: item.CODNODO,
      desnodo: item.DESNODO,
      ore: item.ORE,
      oreprep: item.OREPREP,
      oreprev: item.OREPREV,
      orerest: item.OREREST,
      orediff: item.OREDIFF,
    })),
  };

  return mappedData;
}
